import BasicApplication from "./Basic.application";

import {
    validationControlCurrentRequest,
} from "../../redux/actions/Requests/currentRequestControls/validationControl.currentRequest";

class StudyLeaveApplication extends BasicApplication {
    constructor(options) {
        super(options);
        this.leaveTypeId = options.leaveTypeId;
        this.institutionName = options.institutionName;
        this.educationProgramId = options.educationProgramId;
        this.courseNumberId = options.courseNumberId;
        this.specialtyName = options.specialtyName;
        this.certificateCallNumber = options.certificateCallNumber;
        this.certificateCallDate = options.certificateCallDate;
        this.dateTo = options.dateTo;
        this.dateFrom = options.dateFrom;
        this.confirmation = options.confirmation;
        this.isValid = {
            leaveReasonId: true,
            institutionName: true,
            educationProgramId: true,
            courseNumberId: true,
            specialtyName: true,
            certificateCallNumber: true,
            certificateCallDate: true,
            dateTo: true,
            dateFrom: true,
            confirmation: true,
        };
    }
    static sendToValidation(currentRequest, dispatch) {
        const keysToCheck =  [
                "leaveReasonId",
                // "institutionName",
                "educationProgramId",
                // "courseNumberId",
                // "specialtyName",
                "certificateCallNumber",
                "certificateCallDate",
                "dateTo",
                "dateFrom",
            "confirmation",
            ]

        return (
            this.keyChecker(
                keysToCheck,
                currentRequest,
                dispatch,
            )
        );
    }

    static keyChecker(arrayOfKeys, currentRequest, dispatch) {
        let result = 0;
        arrayOfKeys.forEach((e) => {
            if (
                !Array.isArray(e) &&
                (currentRequest[`${e}`] === null ||
                    currentRequest[`${e}`] === undefined ||
                    currentRequest[`${e}`] === false

                    ||
                    currentRequest[`${e}`] === "")
            ) {
                result += 1;
                dispatch(validationControlCurrentRequest(e, false));
            }
        });
        return !result;
    }
}

export default StudyLeaveApplication;
